import InfoIcon from "@mui/icons-material/Info";
import { createTheme, ThemeProvider, Tooltip } from "@mui/material";
import "./TooltipPopup.scss";

interface TooltipPopupProps {
  text: string;
  id: string;
}

const theme = createTheme({
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: "0.75rem",
          color: "white",
          backgroundColor: "#2b3035",
        },
      },
    },
  },
});

const TooltipPopup = ({ text, id }: TooltipPopupProps) => {
  return (
    <ThemeProvider theme={theme}>
      <div id={id} className="TooltipPopup">
        <Tooltip
          enterTouchDelay={0}
          title={<span style={{ whiteSpace: "pre-line" }}>{text}</span>}
          placement="top"
        >
          <sup><InfoIcon className="icon-size"></InfoIcon></sup>
        </Tooltip>
      </div>
    </ThemeProvider>
  );
};
export default TooltipPopup;
